import { AdminModule } from '../../modules/admin/AdminModule.tsx';


export const AdminRouteElement = () => (
  <AdminModule />
)
